module.exports = __webpack_public_path__ + "img/mt_3.3e1831a4.png";